var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-filter-input"},[_c('FilterInputCourse',{staticClass:"flex-1"}),_vm._v(" "),(_vm.isMobile)?_c('FilterInputMobile',{staticClass:"w-12"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }